import TaskItem from "./TaskItem";
import { TTask } from "../../types";

export type TTaskLayerProps = {
  tasksToShow: TTask[];
  isClickedCheck: boolean;
  answersList: any;
  checkedTasks: any;
};

function TaskItemLayer(props: TTaskLayerProps) {
  const { tasksToShow, isClickedCheck, answersList, checkedTasks } = props;
  let x = 1;
  return (
    <div>
      {tasksToShow.map((task) => (
        <div className="TaskItemLayerContainer" key={(x++).toString()}>
          <h1
            style={{
              fontSize: "36px",
              lineHeight: "37px",
              textAlign: "center",
              fontStyle: "normal",
              fontFamily: "Montserrat",
              fontWeight: "550",
            }}
          >
            {task.displayIndex! > 9
              ? !task.rootId
                ? task.displayIndex
                : ""
              : !task.rootId
                ? "0" + task.displayIndex
                : ""}
          </h1>

          <div
            style={{
              padding: "0.75rem",
              border: "rgba(24, 51, 69, 0.3) solid thin",
              fontWeight: "500",
              wordWrap: "break-word",
            }}
          >
            <TaskItem
              isCorrectlySolved={
                checkedTasks.find((x: any) => x.taskId === task.id)
                  ?.isCorrect === "CORRECT"
              }
              answerList={answersList}
              isCheckButtonClicked={isClickedCheck}
              checked={checkedTasks.find((x: any) => x.taskId === task.id)}
              task={task}
            />

            {task.subTasks ? (
              task.subTasks.map((subtask) => (
                <TaskItem
                  key={(x++).toString()}
                  isCorrectlySolved={
                    checkedTasks.find((x: any) => x.taskId === subtask.id)
                      ?.isCorrect === "CORRECT"
                  }
                  answerList={answersList}
                  isCheckButtonClicked={isClickedCheck}
                  checked={checkedTasks.find(
                    (x: any) => x.taskId === subtask.id,
                  )}
                  task={subtask}
                />
              ))
            ) : (
              <></>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default TaskItemLayer;
